var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom';
import ContainerPainel from '../../../components/container_painel';
import { BotaoAdicionar } from '../../../components/botoes';
import Grid, { PaginationModelDefault } from '../../../components/grid';
import BarraPesquisar from '../../../components/grid_pesquisar';
import { BoxGrid, BoxPrincipal, BoxSuperior } from '../../../components/grid_box';
import { STATUS_API } from '../../../api';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { excluirTipoUnidadePrisional, getTipoUnidadePrisionalParaExclusao, getTiposUnidadesPrisionais } from './tipos_unidades_prisionais.service';
var STORAGE_KEY = 'tipos-unidades-prisionais:listagem';
var MENSAGEM_FALHA = 'Não foi possível carregar os tipos de unidades prisionais. Tente novamente.';
var obterEstadoSalvo = function () {
    var _a, _b, _c;
    try {
        var estado = JSON.parse((_a = sessionStorage.getItem(STORAGE_KEY)) !== null && _a !== void 0 ? _a : '{}');
        return {
            textoBusca: typeof estado.textoBusca === 'string' ? estado.textoBusca : '',
            paginationModel: {
                page: Number.isInteger((_b = estado.paginationModel) === null || _b === void 0 ? void 0 : _b.page) ? estado.paginationModel.page : PaginationModelDefault.page,
                pageSize: [15, 30, 50, 100].includes((_c = estado.paginationModel) === null || _c === void 0 ? void 0 : _c.pageSize) ? estado.paginationModel.pageSize : PaginationModelDefault.pageSize,
            },
        };
    }
    catch (_d) {
        return { textoBusca: '', paginationModel: PaginationModelDefault };
    }
};
export var TiposUnidadesPrisionaisListar = function () {
    var estadoInicial = useState(obterEstadoSalvo)[0];
    var _a = useState(estadoInicial.textoBusca), textoBusca = _a[0], setTextoBusca = _a[1];
    var _b = useState(estadoInicial.paginationModel), paginationModel = _b[0], setPaginationModel = _b[1];
    var _c = useState([]), rows = _c[0], setRows = _c[1];
    var _d = useState(0), totalRegistros = _d[0], setTotalRegistros = _d[1];
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), falha = _f[0], setFalha = _f[1];
    var _g = useState(null), registroExcluir = _g[0], setRegistroExcluir = _g[1];
    var _h = useState(null), modal = _h[0], setModal = _h[1];
    var _j = useState(false), processandoExclusao = _j[0], setProcessandoExclusao = _j[1];
    var navigate = useNavigate();
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoes = getAcoesFuncionalidade(FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS);
    useEffect(function () {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ textoBusca: textoBusca, paginationModel: paginationModel }));
    }, [textoBusca, paginationModel]);
    var carregarDados = function (busca, paginacao) {
        if (busca === void 0) { busca = textoBusca; }
        if (paginacao === void 0) { paginacao = paginationModel; }
        return __awaiter(void 0, void 0, void 0, function () {
            var resposta, paginaAnterior, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsLoading(true);
                        setFalha(false);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, 8, 9]);
                        return [4 /*yield*/, getTiposUnidadesPrisionais(busca || null, paginacao)];
                    case 2:
                        resposta = _b.sent();
                        if (!(resposta.Status === STATUS_API.ERRO)) return [3 /*break*/, 3];
                        if (resposta.httpStatus === 401) {
                            navigate(ROUTES.LOGOUT);
                            return [2 /*return*/];
                        }
                        if (resposta.httpStatus === 403) {
                            navigate(ROUTES.SEM_PERMISSAO);
                            return [2 /*return*/];
                        }
                        setFalha(true);
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(!resposta.dados.length && paginacao.page > 0)) return [3 /*break*/, 5];
                        paginaAnterior = __assign(__assign({}, paginacao), { page: Math.max(0, Math.ceil(resposta.total_registros / paginacao.pageSize) - 1) });
                        setPaginationModel(paginaAnterior);
                        return [4 /*yield*/, carregarDados(busca, paginaAnterior)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/];
                    case 5:
                        setRows(resposta.dados);
                        setTotalRegistros(resposta.total_registros);
                        _b.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        _a = _b.sent();
                        setFalha(true);
                        return [3 /*break*/, 9];
                    case 8:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        void carregarDados();
        // Load the persisted search and pagination exactly once when entering this route.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var pesquisar = function (texto) {
        var novaPaginacao = __assign(__assign({}, paginationModel), { page: 0 });
        setTextoBusca(texto);
        setPaginationModel(novaPaginacao);
        void carregarDados(texto, novaPaginacao);
    };
    var alterarPaginacao = function (novaPaginacao) {
        var paginacaoFinal = novaPaginacao.pageSize === paginationModel.pageSize ? novaPaginacao : __assign(__assign({}, novaPaginacao), { page: 0 });
        setPaginationModel(paginacaoFinal);
        void carregarDados(textoBusca, paginacaoFinal);
    };
    var redirecionarErroAcesso = function (httpStatus) {
        if (httpStatus === 401 || httpStatus === 403) {
            navigate(httpStatus === 401 ? ROUTES.LOGOUT : ROUTES.SEM_PERMISSAO);
            return true;
        }
        return false;
    };
    var solicitarExclusao = function (registro) { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (processandoExclusao)
                        return [2 /*return*/];
                    if (!acoes.EXCLUIR) {
                        navigate(ROUTES.SEM_PERMISSAO);
                        return [2 /*return*/];
                    }
                    setProcessandoExclusao(true);
                    setRegistroExcluir(registro);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, getTipoUnidadePrisionalParaExclusao(registro.id)];
                case 2:
                    resposta = _b.sent();
                    if (!((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO)) return [3 /*break*/, 5];
                    if (redirecionarErroAcesso(resposta.httpStatus))
                        return [2 /*return*/];
                    if (!(resposta.httpStatus === 404)) return [3 /*break*/, 4];
                    return [4 /*yield*/, carregarDados()];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
                case 4:
                    setModal('erro');
                    return [2 /*return*/];
                case 5:
                    setRegistroExcluir({ id: resposta.id, nome: resposta.nome });
                    setModal('confirmacao');
                    return [3 /*break*/, 8];
                case 6:
                    _a = _b.sent();
                    setModal('erro');
                    return [3 /*break*/, 8];
                case 7:
                    setProcessandoExclusao(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var confirmarExclusao = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!registroExcluir || processandoExclusao)
                        return [2 /*return*/];
                    if (!acoes.EXCLUIR) {
                        navigate(ROUTES.SEM_PERMISSAO);
                        return [2 /*return*/];
                    }
                    setProcessandoExclusao(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, excluirTipoUnidadePrisional(registroExcluir.id)];
                case 2:
                    resposta = _c.sent();
                    if (resposta.Status === STATUS_API.ERRO) {
                        if (redirecionarErroAcesso(resposta.httpStatus))
                            return [2 /*return*/];
                        setModal(resposta.httpStatus === 409 ? 'emUso' : 'erro');
                        return [2 /*return*/];
                    }
                    setModal(null);
                    return [4 /*yield*/, carregarDados()];
                case 3:
                    _c.sent();
                    if (((_b = resposta.dados) === null || _b === void 0 ? void 0 : _b.excluido) !== false)
                        setModal('sucesso');
                    return [3 /*break*/, 6];
                case 4:
                    _a = _c.sent();
                    setModal('erro');
                    return [3 /*break*/, 6];
                case 5:
                    setProcessandoExclusao(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var colunas = [{ field: 'nome', headerName: 'Nome', flex: 1, minWidth: 240 }];
    var opcoesAcoes = {
        ROTA: ROUTES.TIPOS_UNIDADES_PRISIONAIS,
        VISUALIZAR: acoes.VISUALIZAR,
        ALTERAR: acoes.ALTERAR,
        EXCLUIR: acoes.EXCLUIR,
        onExcluir: solicitarExclusao,
    };
    return (_jsxs(ContainerPainel, __assign({ pagina: PAGINAS.TIPOS_UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS }, { children: [_jsxs(BoxPrincipal, { children: [_jsxs(BoxSuperior, { children: [_jsx(BarraPesquisar, { filtrarGrid: pesquisar, valorInicial: textoBusca }), acoes.CADASTRAR && _jsx(BotaoAdicionar, { pagina: ROUTES.TIPOS_UNIDADES_PRISIONAIS })] }), falha ? (_jsxs(Box, __assign({ sx: { minHeight: 220, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5 } }, { children: [_jsx(WarningAmberIcon, { sx: { color: '#c49a19', fontSize: 42 } }), _jsx(Typography, { children: MENSAGEM_FALHA }), _jsx(Button, __assign({ variant: 'outlined', onClick: function () { return void carregarDados(); } }, { children: "Recarregar" }))] }))) : (_jsx(BoxGrid, { children: _jsx(Grid, { columns: colunas, rows: rows, OPCOES_FUNCIONALIDADE: opcoesAcoes, TotalRegistros: totalRegistros, isLoading: isLoading, PaginationModel: paginationModel, setPaginationModel: alterarPaginacao, localeText: {
                                noRowsLabel: textoBusca ? 'Nenhum registro encontrado para a pesquisa informada.' : 'Nenhum tipo de unidade prisional cadastrado.',
                                noResultsOverlayLabel: 'Nenhum registro encontrado para a pesquisa informada.',
                            } }) }))] }), _jsxs(Dialog, __assign({ open: modal !== null, onClose: function () { if (!processandoExclusao)
                    setModal(null); }, "aria-labelledby": 'titulo-exclusao-tipo-unidade', fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ id: 'titulo-exclusao-tipo-unidade', sx: { display: 'flex', alignItems: 'center', gap: 1, fontSize: '1.1rem' } }, { children: [modal === 'sucesso' ? _jsx(CheckCircleIcon, { color: 'success' }) : modal === 'erro' ? _jsx(ErrorIcon, { color: 'error' }) : _jsx(WarningAmberIcon, { color: 'warning' }), modal === 'confirmacao' && 'Deseja excluir o tipo de unidade prisional?', modal === 'sucesso' && 'Exclusão realizada', modal === 'emUso' && 'Não é possível excluir o tipo de unidade prisional', modal === 'erro' && 'Não foi possível realizar a Exclusão'] })), _jsx(DialogContent, { children: _jsxs(Typography, __assign({ variant: 'body2' }, { children: [modal === 'confirmacao' && _jsxs(_Fragment, { children: ["O tipo de unidade prisional ", _jsx("strong", { children: registroExcluir === null || registroExcluir === void 0 ? void 0 : registroExcluir.nome }), " ser\u00E1 exclu\u00EDdo definitivamente. Esta a\u00E7\u00E3o n\u00E3o poder\u00E1 ser desfeita."] }), modal === 'sucesso' && 'Tipo de unidade prisional excluído com sucesso.', modal === 'emUso' && _jsxs(_Fragment, { children: ["O tipo de unidade prisional ", _jsx("strong", { children: registroExcluir === null || registroExcluir === void 0 ? void 0 : registroExcluir.nome }), " est\u00E1 vinculado a uma ou mais unidades prisionais e n\u00E3o pode ser exclu\u00EDdo."] }), modal === 'erro' && 'No momento não foi possível excluir o tipo de unidade prisional. Tente novamente mais tarde.'] })) }), _jsxs(DialogActions, __assign({ sx: { px: 3, pb: 2 } }, { children: [_jsx(Button, __assign({ variant: 'contained', color: modal === 'sucesso' ? 'success' : 'secondary', disabled: processandoExclusao, onClick: function () { return setModal(null); } }, { children: modal === 'sucesso' ? 'OK' : 'Voltar' })), modal === 'confirmacao' && _jsx(Button, __assign({ variant: 'contained', color: 'error', disabled: processandoExclusao, onClick: function () { return void confirmarExclusao(); } }, { children: "Excluir" }))] }))] }))] })));
};
export default TiposUnidadesPrisionaisListar;
